'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import isNil from 'lodash/isNil';
import { useTranslation } from 'react-i18next';

// UI lib components
import { Indicator, Text } from '@mantine/core';

// Types
import { UserStatusProps } from './types';

// Style
import * as classes from './styles/index.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function UserStatus({
  user,
  labelProps,
  statusType = 'account',
  ...props
}: UserStatusProps) {
  /* ********************************** HOOKS ********************************* */

  // Localization
  const { t } = useTranslation('User');

  // Styles

  /* ***************************** LOCAL VARIABLES **************************** */

  const isActive = !isNil(user.auth0Id);

  /* ******************************** RENDERING ******************************* */
  return (
    <Indicator
      className={classes.userStatus}
      color={isActive ? 'green' : 'blackroomGray'}
      position="middle-start"
      {...props}
    >
      <Text pl="xs" {...labelProps}>
        {t(`Common.accountStatus.${isActive ? 'active' : 'inactive'}`)}
      </Text>
    </Indicator>
  );
}

export default UserStatus;
